const supplierId = {
	supplier: {
		title: "Supplier",
		subtitle: "Kelola data pemasok bahan baku dan produk",
		table: {
			title: "Data Supplier",
			columns: {
				name: "Nama Supplier",
				pic: "PIC",
				phone: "Nomor Telepon PIC",
				email: "Email",
				address: "Alamat",
				status: "Status",
				action: "Aksi",
			},
			empty_state: {
				title: "Belum ada supplier",
				description: "Tambahkan supplier untuk mulai mencatat pembelian stok.",
			},
		},
		filters: {
			status: "Status",
			all_statuses: "Semua Status",
		},
		status: {
			active: "Aktif",
			inactive: "Nonaktif",
		},
		form: {
			add_title: "Tambah Supplier",
			edit_title: "Ubah Supplier",
			name: "Nama Supplier",
			pic: "PIC",
			phone: "Nomor Telepon PIC",
			email: "Email",
			address: "Alamat",
			status: "Status",
			submit: "Simpan",
			cancel: "Batal",
			add_success: "Supplier berhasil ditambahkan",
			edit_success: "Supplier berhasil diubah",
			errors: {
				name_required: "Nama supplier wajib diisi",
				email_invalid: "Format email tidak valid",
			},
		},
		delete: {
			title: "Hapus Supplier",
			description:
				"Supplier yang dihapus tidak dapat dikembalikan. Lanjutkan menghapus?",
			confirm: "Hapus",
			cancel: "Batal",
			success: "Supplier berhasil dihapus",
		},
	},
};

export default supplierId;
